import { render } from "./user-list.vue?vue&type=template&id=954b95f6&scoped=true"
import script from "./user-list.vue?vue&type=script&lang=js"
export * from "./user-list.vue?vue&type=script&lang=js"

import "./user-list.vue?vue&type=style&index=0&id=954b95f6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-954b95f6"]])

export default __exports__